var $055104befa589c0a$exports = {};
$055104befa589c0a$exports = {
  "backButton": args => "\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03BF ".concat(args.prevMenuButton),
  "moreActions": "\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03B5\u03BD\u03AD\u03C1\u03B3\u03B5\u03B9\u03B5\u03C2",
  "unavailable": "\u039C\u03B7 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF, \u03B1\u03BD\u03AC\u03C0\u03C4\u03C5\u03BE\u03B7 \u03B3\u03B9\u03B1 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2"
};
export { $055104befa589c0a$exports as default };